import config from '../Config';
import LanguageStore, { languageSlug } from './LanguageStore';
import { RootStore } from './RootStore';
import RouteStore from './RouteStore';
import SsoStore from './SsoStore';

export default class SelfServiceStore {
  private routeStore: RouteStore;
  private languageStore: LanguageStore;
  private ssoStore: SsoStore;

  constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.languageStore = rootStore.languageStore;
    this.ssoStore = rootStore.ssoStore;
  }

  public redirectToSelfService = () => {
    const {
      languageStore: { currentLanguage },
      ssoStore,
      routeStore,
    } = this;

    const customerType = ssoStore.loggedIn && ssoStore.customer && ssoStore.customer.type;
    const segmentSlug = customerType === 'B2B' ? '/ari' : '';

    routeStore.push(config.teliaWebSelfServiceUrl + languageSlug(currentLanguage) + segmentSlug);
  };
}
